"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = requireTokens;
const constants_1 = require("../constants");
function requireTokens(req, res, next) {
    if (!req.headers[constants_1.RequestHeaders.AccessToken] ||
        !req.headers[constants_1.RequestHeaders.RefreshToken]) {
        res.sendStatus(401);
    }
    else {
        next();
    }
}
